import {brtManagerLoginUser, getStatActRightKeys} from '@/assets/js/api';
export default {
  state: {
    // 用户信息
    userInfo: {},
    // 用户权限
    rightKey: {},
    // 机构列表
    actList: [],
    // 当前机构信息
    currentActInfo: null,
    // 当前权限信息
    currentRightKey: [],
    // loading集合，用来处理局部loading展示
    loadingMap: '{}'
  },
  getters: {
    // 用户信息
    brtFirstName: state => {
      if (state.userInfo.name) {
        return state.userInfo.name.substr(0, 1);
      }
      return '';
    },
    // 诉讼权限
    litigationRight: state => {
      if (state.currentRightKey.length > 0) {
        return state.currentRightKey.includes('brt.oper.managerStatPlatform') && state.currentRightKey.includes('brt.oper.civil');
      }
      return false;
    },
    // 调解权限
    mediateRight: state => {
      if (state.currentRightKey.length > 0) {
        return state.currentRightKey.includes('brt.oper.managerStatPlatform') && state.currentRightKey.includes('brt.oper.noSued');
      }
      return false;
    }
  },
  mutations: {
    // 设置用户相关信息
    SET_BRT_USERDATA:  (state, userData) => {
      // 用户信息
      state.userInfo = userData.uimUser;
      // 用户权限
      state.rightKey = userData.rightKeyMap;
      // 机构列表
      state.actList = userData.accountList;
    },
    // 切换机构
    BRT_CHANGE_ORGAN: (state, organ) => {
      const {
        actInfo, rights
      } = organ;
      if (rights) {
        state.rightKey[actInfo.actId] = rights;
        // 设置默认权限
        state.currentRightKey = rights;
      } else {
        // 如果没有权限，使用旧的。
        state.currentRightKey = state.rightKey[actInfo.actId];
      }
      // 设置默认机构
      state.currentActInfo = actInfo;
    },
    // 开始loading
    START_LOADING: (state, key) => {
      const loadingMap = JSON.parse(state.loadingMap);
      if (Object.prototype.hasOwnProperty.call(loadingMap, key)) {
        loadingMap[key]++;
      } else {
        loadingMap[key] = 1;
      }
      state.loadingMap = JSON.stringify(loadingMap);
    },
    // 关闭loading
    END_LOADING: (state, key) => {
      const loadingMap = JSON.parse(state.loadingMap);
      if (Object.prototype.hasOwnProperty.call(loadingMap, key)) {
        loadingMap[key]--;
        if (loadingMap[key] < 0) {
          loadingMap[key] = 0;
        }
      }
      state.loadingMap = JSON.stringify(loadingMap);
    }
  },
  actions: {
    // 本地登录
    brtManagerLogin({commit}) {
      return new Promise((resolve, reject) => {
        brtManagerLoginUser().then(response => {
          if (response && response.code === 200) {
            commit('SET_BRT_USERDATA', response.data);
            resolve(response.data);
          } else {
            reject(response);
          }
        })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 切换机构
    brtChangeOrgan({commit}, data) {
      return new Promise((resolve, reject) => {
        const flag = data.isDefault;
        if (!flag) {
          // 获取当前机构的最新权限
          const params = {actId: data.actId};
          getStatActRightKeys(params).then(res => {
            if (res.code && res.code.toString() === '200') {
              commit('BRT_CHANGE_ORGAN', {
                actInfo: data,
                rights: res.data
              });
              resolve(res.data);
            } else {
              commit('BRT_CHANGE_ORGAN', {
                actInfo: data,
                rights: null
              });
              reject(res);
            }
          });
        } else {
          // 删除默认项
          delete data.isDefault;
          commit('BRT_CHANGE_ORGAN', {
            actInfo: data,
            rights: null
          });
          resolve(null);
        }
      });
    },
  }
};
